// extracted by mini-css-extract-plugin
export default {"button":"GradientButton_button__2wulF"};